import  {baseActions}  from "./base.actions";

export const certdocumentActions = {
    add,
    gets,
    get,
    delete: _delete
};

function add(obj,func=null) {
    
    return baseActions.add(obj,'CertificationDocument',null,func)
}

function gets() {
    return baseActions.getall('CertificationDocument');
}

function get(id)
{
    return baseActions.get('CertificationDocument',id);
}
function _delete(id,func =null)
{
    return baseActions.delete(id,'CertificationDocument',func);
}
